import { useState, useEffect } from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Font,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from './FormatDate';

import { useLoaderData, useParams } from "react-router-dom";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

export function InfValPautDecField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;

  const [docResp, setDocResp] = useState(
    savedData?.docResp ? savedData?.docResp : especialistaFullName
  );
  const [docColegiado, setDocColegiado] = useState(
    savedData?.docColegiado
      ? savedData?.docColegiado
      : autoEspecialistaData?.meta?.colegiado
  );
  const [docEmailDoct, setDocEmailDoct] = useState(
    savedData?.docEmailDoct
      ? savedData?.docEmailDoct
      : autoEspecialistaData?.email
  );
  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );
  const [docTfnoPac, setDocTfnoPac] = useState(
    savedData?.docTfnoPac
      ? savedData?.docTfnoPac
      : autoPacienteData?.meta?.telefono
  );
  const [docEmailPacie, setDocEmailPacie] = useState(
    savedData?.docEmailPacie
      ? savedData?.docEmailPacie
      : autoPacienteData?.email
  );
  const [docDiagn, setDocDiagn] = useState(
    savedData?.docDiagn ? savedData?.docDiagn : ""
  );
  const [docDiasDecal, setDocDiasDecal] = useState(
    savedData?.docDiasDecal ? savedData?.docDiasDecal : ""
  );
  const [docMedicAct, setDocMedicAct] = useState(
    savedData?.docMedicAct ? savedData?.docMedicAct : ""
  );
  const [docFarmRetirad, setDocFarmRetirad] = useState(
    savedData?.docFarmRetirad ? savedData?.docFarmRetirad : ""
  );
  const [docFarmNuev, setDocFarmNuev] = useState(
    savedData?.docFarmNuev ? savedData?.docFarmNuev : ""
  );

  let data = {
    docResp: docResp,
    docColegiado: docColegiado,
    docFecha: docFecha,
    docPacie: docPacie,
    docTfnoPac: docTfnoPac,
    docEmailPacie: docEmailPacie,
    docDiagn: docDiagn,
    docDiasDecal: docDiasDecal,
    docMedicAct: docMedicAct,
    docEmailDoct: docEmailDoct,
    docFarmRetirad: docFarmRetirad,
    docFarmNuev: docFarmNuev,
  };

  useEffect(() => {
    updateData(data);
  }, [
    docResp,
    docColegiado,
    docFecha,
    docPacie,
    docTfnoPac,
    docEmailPacie,
    docDiagn,
    docDiasDecal,
    docMedicAct,
    docEmailDoct,
    docFarmRetirad,
    docFarmNuev,
  ]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/InfValPautDec.docx"
      );
      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      doc.setData({
        responsable: docResp,
        colegiado: docColegiado,
        date: FormatDate(docFecha),
        paciente: docPacie,
        tfnoPacie: docTfnoPac,
        emailPacie: docEmailPacie,
        diagn: docDiagn,
        diasDecal: docDiasDecal,
        medicAct: docMedicAct,
        emailDoct: docEmailDoct,
        farmRetirad: docFarmRetirad,
        farmNuev: docFarmNuev,
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "informe-valoracion-pauta-decalaje.docx");
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [
    docResp,
    docColegiado,
    docFecha,
    docPacie,
    docTfnoPac,
    docEmailPacie,
    docDiagn,
    docDiasDecal,
    docMedicAct,
    docEmailDoct,
    docFarmRetirad,
    docFarmNuev,
  ]);
  return (
    <>
      <div className='docFormContainer'>
      <div className="grid--2col">
        <div className='field'>
          <label htmlFor='docResp'>Responsable</label>
          <div className='control'>
            <input
              className='input'
              id='docResp'
              required
              type='text'
              value={docResp}
              onChange={(e) => setDocResp(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docColegiado'>Número de Colegiado</label>
          <div className='control'>
            <input
              className='input'
              id='docColegiado'
              required
              type='text'
              value={docColegiado}
              onChange={(e) => setDocColegiado(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docEmailDoct'>Email del responsable</label>
          <div className='control'>
            <input
              className='input'
              id='docEmailDoct'
              required
              type='email'
              value={docEmailDoct}
              onChange={(e) => setDocEmailDoct(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFecha'>Fecha visita</label>
          <div className='control'>
            <input
              className='input'
              id='docFecha'
              required
              type='date'
              value={docFecha}
              onChange={(e) => setDocFecha(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docPacie'>Nombre del paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docPacie'
              required
              type='text'
              value={docPacie}
              onChange={(e) => setDocPacie(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docTfnoPac'>Teléfono del paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docTfnoPac'
              required
              type='number'
              value={docTfnoPac}
              onChange={(e) => setDocTfnoPac(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docEmailPacie'>Email del paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docEmailPacie'
              required
              type='email'
              value={docEmailPacie}
              onChange={(e) => setDocEmailPacie(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDiagn'>Diagnóstico</label>
          <div className='control'>
            <input
              className='input'
              id='docDiagn'
              required
              type='text'
              value={docDiagn}
              onChange={(e) => setDocDiagn(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDiasDecal'>Días de decalaje</label>
          <div className='control'>
            <input
              className='input'
              id='docDiasDecal'
              required
              type='number'
              value={docDiasDecal}
              onChange={(e) => setDocDiasDecal(e.target.value)}
            />
          </div>
        </div>
        </div>
        <div className='field'>
          <label htmlFor='docMedicAct'>Medicación actual</label>
          <div className='control'>
            <textarea
              className='textarea'
              id='docMedicAct'
              required
              value={docMedicAct}
              onChange={(e) => setDocMedicAct(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFarmRetirad'>Fármacos retirados</label>
          <div className='control'>
            <textarea
              className='textarea'
              id='docFarmRetirad'
              required
              value={docFarmRetirad}
              onChange={(e) => setDocFarmRetirad(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFarmNuev'>Nuevos fármacos</label>
          <div className='control'>
            <textarea
              className='textarea'
              id='docFarmNuev'
              required
              value={docFarmNuev}
              onChange={(e) => setDocFarmNuev(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className='btn-dwnld'>
        

        {showDocxLink && (
          <a className='button is-link' href='#!' onClick={generateDocx}>
            Descargar DOCX
          </a>
        )}
      </div>

      
    </>
  );
}


